import axiosInstance from "./axiosInstance";

const getAllPosts = async ({pageParam = 1}) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const {data} = await axiosInstance.get(
      `/api/posts?page=${pageParam}&limit=5`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return {
      posts: data.posts,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    throw new Error("Error fetching user points.");
  }
};

export default getAllPosts;
